import { Component } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedTextTag, OptimusPlainLink, SpacingSmallRight, EllipsizedSpan } from '@mews-commander/ui';
import { NotificationContentWrapper, NotificationContentElement, NotificationLabel, LabelIcon } from './style';
import { NotificationType } from './types';

interface Props {
    isSeen?: boolean;
    label?: React.ReactNode;
    icon?: string;
    onClick?: () => void;
    type: NotificationType;
}

export default class ExportNotification extends Component<React.PropsWithChildren<Props>> {
    render() {
        const { isSeen, label, icon, children, onClick, type } = this.props;

        return (
            <NotificationContentWrapper data-test-notification-type={type}>
                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                <NotificationLabel highlighted={!isSeen}>
                    {!isSeen && (
                        <SpacingSmallRight>
                            <LocalizedTextTag variant="warning" textKey={TextKey.New} />
                        </SpacingSmallRight>
                    )}
                    {/* @ts-expect-error $TSFixMeError: Type '$TSFixMeFunction | undefined' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'. */}
                    <OptimusPlainLink onClick={onClick} inherit>
                        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                        <LabelIcon value={icon} />
                        <EllipsizedSpan>{label}</EllipsizedSpan>
                    </OptimusPlainLink>
                </NotificationLabel>
                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                <NotificationContentElement highlighted={!isSeen}>{children}</NotificationContentElement>
            </NotificationContentWrapper>
        );
    }
}
